import CONFIG from '$config'

const baseOrigin = !(typeof window === 'undefined')
    ? window.location.origin
    : (() => {
          if (CONFIG.PROFILE === 'local') {
              if (CONFIG.USE_HTTPS_ORIGIN) {
                  return `https://local-m.pay.naver.com`
              }

              const port = CONFIG.PORT
              return `http://local-m.pay.naver.com${port ? `:${port}` : ''}`
          }

          return CONFIG.PAY_MAIN_URI_BASE || CONFIG.URL.NEW_PAY
      })()

export default baseOrigin
